import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "flex flex-col md:flex-row md:mt-16" }
const _hoisted_2 = {
  key: 0,
  class: "flex-1 xl:ml-48 sm:ml-24 p-8"
}
const _hoisted_3 = { class: "mt-5 font-bold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex mt-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-36 h-36 mr-4 bg-accent-yellow rounded-md",
    src: _imports_0
  })
], -1)
const _hoisted_5 = { class: "flex mt-4" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "mt-8 font-bold" }
const _hoisted_8 = { class: "flex mt-4 items-center" }
const _hoisted_9 = { class: "mt-8 font-bold" }
const _hoisted_10 = { class: "flex mt-4 items-center" }
const _hoisted_11 = { class: "invisible mt-8 font-bold" }
const _hoisted_12 = { class: "invisible flex mt-4 xl:space-x-44 sm:space-x-24 lg:space-x-44 items-center" }
const _hoisted_13 = { class: "invisible xl:max-w-xs sm:max-w-md text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile_side_menu = _resolveComponent("profile-side-menu")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_input = _resolveComponent("base-input")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_profile_side_menu),
    (_ctx.user != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.t('profile.picture')), 1),
          _hoisted_4,
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              href: _ctx.getEditPage(),
              target: "_blank"
            }, [
              _createVNode(_component_base_button, {
                text: _ctx.t('profile.edit'),
                "on-click": _ctx.buttonClick,
                "custom-style": "primary",
                "icon-shown": false,
                class: "px-2 mb-2"
              }, null, 8, ["text", "on-click"])
            ], 8, _hoisted_6)
          ], 512), [
            [_vShow, false]
          ]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.t('profile.username')), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_base_input, {
              ref: _ctx.user.preferred_username,
              "model-value": _ctx.user.preferred_username,
              placeholder: _ctx.t('profile.username'),
              disabled: !_ctx.user.preferred_username
            }, null, 8, ["model-value", "placeholder", "disabled"])
          ]),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.t('profile.email')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_base_input, {
              ref: _ctx.user.email,
              "model-value": _ctx.user.email,
              placeholder: "Email",
              disabled: !_ctx.user.email
            }, null, 8, ["model-value", "disabled"])
          ]),
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.t('profile.delete')), 1),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.t('profile.delete-info')), 1),
            _createVNode(_component_base_button, {
              text: _ctx.t('profile.delete-button'),
              "on-click": _ctx.buttonClick,
              "custom-style": "invisible ghost-red",
              "icon-shown": true,
              "custom-icon": "delete"
            }, null, 8, ["text", "on-click"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}